module.exports = "images/agosto94.svg";